export const LevelOfStudyRef: { [id: string]: string; } = {
    "U": "Undergraduate",
    "P": "Postgraduate"
};